export default {
  dtInventory: {
    label: 'kardex.dtInventory',
    field: 'dtInventory',
    render: true,
    fixed: true,
    type: 'general',
  },
  hrInventory: {
    label: 'kardex.hrInventory',
    field: 'hrInventory',
    render: true,
    fixed: true,
    type: 'general',
  },
  cdDeposit: {
    label: 'kardex.cdDeposit',
    field: 'cdDeposit',
    render: true,
    fixed: true,
    type: 'general',
  },
  cdMotion: {
    label: 'kardex.cdMotion',
    field: 'cdMotion',
    render: true,
    fixed: false,
    type: 'general',
  },
  tpMotion: {
    label: 'kardex.tpMotion',
    field: 'cdMotion',
    render: true,
    fixed: false,
    type: 'general',
  },
  qtMotion: {
    label: 'kardex.qtMotion',
    field: 'qtMotion',
    render: true,
    fixed: false,
    type: 'decimal',
  },
  vlTotal: {
    label: 'kardex.vlTotal',
    vlTotal: 'vlTotal',
    render: true,
    fixed: false,
    type: 'currency',
  },
  qtStock: {
    label: 'kardex.qtStock',
    field: 'qtStock',
    render: true,
    fixed: false,
    type: 'currency-alt',
  },
  vlDpac: {
    label: 'kardex.vlDpac',
    field: 'vlDpac',
    render: true,
    fixed: false,
    type: 'currency',
  },
  vlAmount: {
    label: 'kardex.vlAmount',
    field: 'vlAmount',
    render: true,
    fixed: false,
    type: 'currency',
  },
}
